import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { applyAppUpdateWhenAllowed, setAppUpdateRegistration, setAppUpdateServiceWorkerUpdater } from './app_update.ts';

// Registers the service worker and reloads onto a new one once the playback gate allows. The
// check for a new worker lives in app_update.ts: the music walk starts it whenever the server
// reports a bundle hash other than the running one (at launch, on a live-update ping or reconnect,
// on return to the foreground), and nothing else does - a check on every page navigation reloaded
// the iOS app with nothing deployed (issue #3910).
export function useServiceWorkerHelper() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      setAppUpdateRegistration({ swUrl, registration });
    },
  });

  useEffect(() => {
    setAppUpdateServiceWorkerUpdater(updateServiceWorker);
  }, [updateServiceWorker]);

  useEffect(() => {
    if (needRefresh) {
      applyAppUpdateWhenAllowed();
    }
  }, [needRefresh]);
}
